export const messages = {
  en: {
    goods: {
      productNamePlaceholder: 'Enter product name',
      product: {
        title: 'Products',
        id: 'Product ID',
        category: 'Category',
        name: 'Name',
        warehouse: 'Warehouse',
        sales: 'Sales',
        stock: 'Stock',
        price: 'Price',
        sort: 'Sort',
        status: 'Status',
        createTime: 'Create Time',
        operations: 'Operations'
      },
      instock: {
        title: 'Inbound Records',
        shop: 'Shop',
        orderId: 'Order No',
        applicant: 'Applicant',
        applyTime: 'Apply Time',
        status: 'Status',
        productName: 'Product',
        spec: 'Specification',
        quantity: 'Quantity',
        price: 'Price',
        amount: 'Amount'
      },
      outstock: {
        title: 'Outbound Records',
        shop: 'Shop',
        orderId: 'Order No',
        applicant: 'Applicant',
        applyTime: 'Apply Time',
        status: 'Status',
        productName: 'Product',
        spec: 'Specification',
        quantity: 'Quantity',
        price: 'Price',
        amount: 'Amount'
      },
      seckill: {
        title: 'Seckill Products',
        shop: 'Shop',
        productName: 'Product',
        hours: 'Seckill Hours',
        duration: 'Duration Hours',
        limit: 'Purchase Limit',
        singlePurchase: 'Single Purchase',
        seckillPrice: 'Seckill Price',
        originalPrice: 'Original Price',
        stock: 'Stock',
        status: 'Status',
        timeRange: 'Time Range'
      }
    }
  },
  zh: {
    goods: {
      productNamePlaceholder: '请输入商品名称',
      product: {
        title: '商品管理',
        id: '商品ID',
        category: '商品分组',
        name: '商品名称',
        warehouse: '仓库',
        sales: '销量',
        stock: '库存',
        price: '价格',
        sort: '排序',
        status: '状态',
        createTime: '创建时间',
        operations: '操作'
      },
      instock: {
        title: '入库记录',
        shop: '商铺',
        orderId: '订单编号',
        applicant: '申请人',
        applyTime: '申请时间',
        status: '状态',
        productName: '商品名称',
        spec: '规格',
        quantity: '数量',
        price: '价格',
        amount: '金额'
      },
      outstock: {
        title: '出库记录',
        shop: '店铺',
        orderId: '订单编号',
        applicant: '申请人',
        applyTime: '申请时间',
        status: '状态',
        productName: '商品名称',
        spec: '规格',
        quantity: '数量',
        price: '价格',
        amount: '金额'
      },
      seckill: {
        title: '秒杀商品',
        shop: '店铺',
        productName: '产品名称',
        hours: '秒杀小时',
        duration: '持续小时',
        limit: '有效期内购买',
        singlePurchase: '一次购买数量',
        seckillPrice: '秒杀金额',
        originalPrice: '单买金额',
        stock: '限量',
        status: '状态',
        timeRange: '有效期'
      }
    }
  }
}